export const COOKIE_NAME_JWT = 'bh_jwt'
export const COOKIE_NAME_SALES_AGENT_JWT = 'bh_sales_agent_jwt'
export const COOKIE_NAME_CURRENCY = 'bh_currency'
export const COOKIE_NAME_USER_GROUP = 'bh_user_group'
export const COOKIE_NAME_SALES_AGENT_GROUP = 'bh_sales_agent_group'

export const COOKIE_NAME_LOCATION_PREFERENCE = 'bh_location_preference'
export const COOKIE_NAME_SESSION_ID = 'bh_session_id'

export const HEADER_NAME_DETECTED_DEVICE = 'x-detected-device'

export const QUERY_PARAM_SEARCH = 'q'
export const QUERY_PARAM_PAGE = 'p'
export const QUERY_PARAM_SORT = 'sort'
export const QUERY_PARAM_VIEW_MODE = 'viewMode'
export const QUERY_PARAM_PATHS = 'paths'
export const QUERY_PARAM_VALUE_DIVIDER = '~'
export const QUERY_PARAM_PREVIOUS_PATH = 'previousPath'
export const UPDATE_ROUTER_MODE_REPLACE = 'replace'
export const UPDATE_ROUTER_MODE_PUSH = 'push'
export const QUERY_PARAM_CATEGORY_BREADCRUMBS = 'previousCategoryBreadcrumbs'
export const QUERY_PARAM_CATEGORY_ID = 'previousCategoryId'

export const PRODUCT_TYPE_SIMPLE = 'simple'
export const PRODUCT_TYPE_CONFIGURABLE = 'configurable'
export const PRODUCT_TYPE_GROUPED = 'grouped'
export const PRODUCT_TYPE_BUNDLE = 'bundle'
export const PRODUCT_TYPE_GIFTCARD = 'giftcard'
export const PRODUCT_TYPE_VIRTUAL = 'virtual'
export const RECOMMENDATION_PRODUCT_TYPE_RELATED = 'related'
export const RECOMMENDATION_PRODUCT_TYPE_UPSELLS = 'upsells'
export const RECOMMENDATION_PRODUCT_TYPE_CROSSSEL = 'crosssell'

export const PRODUCT_OPTION_CONFIGURABLE = 'configurable'
export const PRODUCT_OPTION_BUNDLE = 'bundle'
export const PRODUCT_OPTION_GIFTCARD = 'giftcard'
export const PRODUCT_OPTION_CUSTOM = 'custom'

export const PRODUCT_GIFTCARD_TYPE_PHYSICAL = 'Physical'
export const PRODUCT_GIFTCARD_TYPE_VIRTUAL = 'Virtual'
export const PRODUCT_GIFTCARD_TYPE_COMBINED = 'Combined'

export const PRODUCT_BUNDLE_PRICE_TYPE_DYNAMIC = 'dynamic'

export const PRICE_MODE_DEFAULT = 'default'
export const PRICE_MODE_STARTING_FROM = 'starting-from'
export const PRICE_MODE_FROM_TO = 'from-to'

export const CLERK_SEARCH_LIMIT = 200
export const CLERK_LIVE_SEARCH_TYPE = 'live-search'
export const CLERK_SEARCH_PAGE_TYPE = 'search-page'
export const SEARCH_PREVIEW_IDENTIFIER = 'search_dialog_preview'

export const PAGE_PATH_HOME = '/'
export const PAGE_PATH_SEARCH = '/search/'
export const PAGE_PATH_LOGIN = '/login/'
export const PAGE_PATH_RESET_PASSWORD = '/reset-password/'
export const PAGE_PATH_REGISTER = '/register/'
export const PAGE_PATH_CUSTOMER = '/customer/'
export const PAGE_PATH_GUEST = '/guest/'
export const PAGE_PATH_CUSTOMER_ORDER_DETAIL = '/customer/order/id/'
export const PAGE_PATH_GUEST_ORDER = '/guest/order/'
export const PAGE_PATH_GUEST_ORDER_DETAIL = '/guest/order/id/'
export const PAGE_PATH_CUSTOMER_RETURN_DETAIL = `${PAGE_PATH_CUSTOMER}return/id/`
export const PAGE_PATH_CUSTOMER_RETURN_CREATE = `${PAGE_PATH_CUSTOMER}return/create/order/id/`
export const PAGE_PATH_GUEST_RETURN_CREATE = `${PAGE_PATH_GUEST}return/create/order/id/`
export const PAGE_PATH_GUEST_RETURN_DETAIL = `${PAGE_PATH_GUEST}return/id/`
export const PAGE_PATH_SALES_AGENT_LOGIN = '/sales-agent-login/'
export const PAGE_PATH_SALES_AGENT_RESET_PASSWORD = '/sales-agent-reset-password/'
export const PAGE_PATH_SALES_AGENT = '/sales-agent/'
export const PAGE_PATH_SALES_AGENT_PROFILE = `${PAGE_PATH_SALES_AGENT}profile/`
export const PAGE_PATH_SALES_AGENT_ORDERS_RETURNS = `${PAGE_PATH_SALES_AGENT}orders/`
export const PAGE_PATH_SALES_AGENT_ORDER_DETAIL = `${PAGE_PATH_SALES_AGENT}order/id/`
export const PAGE_PATH_SALES_AGENT_QUOTES = `${PAGE_PATH_SALES_AGENT}quotes/`
export const PAGE_PATH_SALES_AGENT_QUOTE_DETAIL = `${PAGE_PATH_SALES_AGENT}quote/id/`
export const PAGE_PATH_SALES_AGENT_CLIENTS = `${PAGE_PATH_SALES_AGENT}clients/`
export const PAGE_PATH_SALES_AGENT_SHAREABLE_QUOTE = 'sales-agent-shareable-quote/'
export const PAGE_PATH_PAYMENT_PROCESS = `/payment/process/`
export const PAGE_PATH_PAY_BY_LINK = `/paybylink/`

export const PAGE_PATH_PROFILE = `${PAGE_PATH_CUSTOMER}profile/`
export const PAGE_PATH_ADDRESS_BOOK = `${PAGE_PATH_CUSTOMER}address-book/`
export const PAGE_PATH_ADDRESS_BOOK_ADD = `${PAGE_PATH_CUSTOMER}address-book/add/`
export const PAGE_PATH_ADDRESS_BOOK_EDIT = `${PAGE_PATH_CUSTOMER}address-book/edit/`
export const PAGE_PATH_PAYMENTS = `${PAGE_PATH_CUSTOMER}stored-payments/`
export const PAGE_PATH_WISHLIST = `/wishlist/`
export const PAGE_PATH_ORDERS_RETURNS = `${PAGE_PATH_CUSTOMER}orders/`
export const PAGE_PATH_SUBSCRIPTIONS = `${PAGE_PATH_CUSTOMER}out-of-stock-subscriptions/`
export const PAGE_PATH_POINTS = `${PAGE_PATH_CUSTOMER}reward-points/`
export const PAGE_PATH_CUSTOMER_SALES_AGENTS_LIST = `${PAGE_PATH_CUSTOMER}sales-agents/list/`
export const PAGE_PATH_CUSTOMER_SALES_AGENTS_DETAIL = `${PAGE_PATH_CUSTOMER}sales-agent/id/`
export const PAGE_PATH_CUSTOMER_SALES_AGENTS_QUOTES = `${PAGE_PATH_CUSTOMER}sales-agents/quotes/`
export const PAGE_PATH_CUSTOMER_SALES_AGENTS_QUOTE_DETAIL = `${PAGE_PATH_CUSTOMER}sales-agents/quote/id/`

export const PAGE_PATH_CART = '/cart/'
export const PAGE_PATH_CHECKOUT = '/checkout/'
export const PAGE_PATH_CHECKOUT_SUCCESS = '/checkout/success/'

export const PAGE_PATH_SHAREABLE_WISHLIST = 'shareable-wishlist/'

export const PATHNAME_MAINTENANCE = '/_maintenance'
export const PATHNAME_ERROR = '/_error'
export const PATHNAME_ERROR_500 = '/500'

export const LOCALSTORAGE_RECENTLY_VIEWED_PRODUCTS = 'bh_recently_viewed'
export const LOCALSTORAGE_KEY_GUEST_ORDERS = 'bh_guest_orders'
export const LOCALSTORAGE_KEY_DIALOG = 'bh_dialog_'
export const LOCALSTORAGE_KEY_SCRATCH_AND_WIN = 'bh_scratch_and_win_'
export const LOCALSTORAGE_KEY_NEWSLETTER_DIALOG = 'bh_newsletter_dialog'
export const LOCALSTORAGE_KEY_COMPARABLE_PRODUCTS = 'bh_comparable_products'
export const LOCALSTORAGE_KEY_ORIGINAL_LOCATION = 'bh_original_location'
export const LOCALSTORAGE_KEY_CHECKOUT = 'bh_checkout'
export const LOCALSTORAGE_KEY_SUGGESTED_STORE = 'bh_suggested_store'
export const LOCALSTORAGE_KEY_PAY_BY_LINK = 'bh_pay_by_link'
export const LOCALSTORAGE_KEY_BH_TRACKING_CONTEXT = 'bh-list-context'

export const WINDOW_STATE_KEY_CATEGORY_SCROLL = 'bh_category_scroll'

export const BH_SEARCH_ID = 'bh_search_id'

export const USER_GROUP_NOT_LOGGED_IN = 0
export const SALES_AGENT_GROUP_NOT_LOGGED_IN = 0

export const USER_GUEST = {
	isLoggedIn: false,
	groupId: USER_GROUP_NOT_LOGGED_IN,
}
export const SALES_AGENT_GUEST = {
	isLoggedIn: false,
	groupId: SALES_AGENT_GROUP_NOT_LOGGED_IN,
}

export const USER_STATUS_LOGGED = 'logged'
export const USER_STATUS_GUEST = 'guest'

export const AUTH_ACTION = {
	RENDER: 'render',
	REDIRECT_TO_LOGIN: 'redirectToLogin',
	REDIRECT_TO_HOME: 'redirectToHome',
	REDIRECT_TO_ACCOUNT: 'redirectToAccount',
	NOT_FOUND: 'notFound',
}

export const MANAGE_GIFTCARD_TYPES = false

export const EASY_RETURN = 'easy_return'
export const NORMAL_RETURN = 'normal_return'
export const IBAN_REQUIRED_FOR_RMA = 'iban_required_for_rma'
export const SIZE_GUIDE_IDENTIFIER = 'size_guide'

export const RESTRICTION_MODE_LOGIN = 'login-only'
export const RESTRICTION_MODE_LOGIN_REGISTER = 'login-register'

export const PRODUCTS_MODE_CATEGORY = 'category'
export const PRODUCTS_MODE_SEARCH = 'search'
export const PRODUCTS_MODE_GLOBAL_CATALOG = 'global-catalog'
export const PRODUCTS_MODE_UNKNOWN = 'unknown'

export const CATALOG_DEFAULT_SORT = { code: 'default', direction: 'asc' }
export const CATALOG_DEFAULT_VIEW_MODE = 'default'

export const BLOG_CONTENT_TYPE = 'blog'
export const BLOG_DEFAULT_SORT = { code: 'date', direction: 'desc' }
export const BLOG_FILTERS_KEYS = ['tags']

export const SHIPPING_ADDRESS_STORAGE_KEY = 'shipping-address'
export const BILLING_ADDRESS_STORAGE_KEY = 'billing-address'
export const BILLING_ADDRESS_EXPLICIT_SELECTION_STORAGE_KEY = 'billing-address-explicit-selection'
export const SAME_AS_SHIPPING_STORAGE_KEY = 'same-as-shipping'
export const SHIPPING_METHOD_STORAGE_KEY = 'shipping-method'
export const SHIPPING_METHOD_TITLE_STORAGE_KEY = 'shipping-method-title'
export const SHIPPING_TYPE_STORAGE_KEY = 'shipping-type'
export const EMAIL_STORAGE_KEY = 'email'
export const EXTRA_CONSENTS_STORAGE_KEY = 'extra-consents'
export const NEWSLETTER_STORAGE_KEY = 'newsletter'
export const TERMS_AND_CONDITIONS_STORAGE_KEY = 'terms-and-conditions'
export const PAYMENT_METHOD_STORAGE_KEY = 'payment-method'
export const PAYMENT_METHOD_TITLE_STORAGE_KEY = 'payment-method-title'
export const PAYMENT_METHOD_ADDITIONAL_DATA_STORAGE_KEY = 'payment-method-additional-data'
export const INVOICE_STORAGE_KEY = 'invoice'
export const PASSWORD_STORAGE_KEY = 'password'
export const PICKUP_STORE_STORAGE_KEY = 'pickup-store'
export const FLOW_TYPE_STORAGE_KEY = 'flow-type'
export const CHECKOUT_TYPE_STORAGE_KEY = 'checkout-type'

export const EMPTY_OBJECT = {}
export const EMPTY_ARRAY = []

export const SHIPPING_ADDRESS_DEFAULT_VALUE = EMPTY_OBJECT
export const BILLING_ADDRESS_DEFAULT_VALUE = EMPTY_OBJECT
export const POSTCODE_DEFAULT_VALUE = ''

export const CARRIER_CODE_PICKUP = 'pickupinstore'

export const EMAIL_VALIDATION_ORDER = 10
export const SHIPPING_TYPE_VALIDATION_ORDER = 30
export const PICKUP_STORE_VALIDATION_ORDER = 40
export const SHIPPING_ADDRESS_VALIDATION_ORDER = 40
export const SHIPPING_METHOD_VALIDATION_ORDER = 50
export const NEWSLETTER_VALIDATION_ORDER = 60
export const EXTRA_CONSENTS_VALIDATION_ORDER = 70
export const TERMS_AND_CONDITIONS_VALIDATION_ORDER = 80
export const PAYMENT_METHOD_VALIDATION_ORDER = 90
export const BILLING_ADDRESS_VALIDATION_ORDER = 100
export const INVOICE_VALIDATION_ORDER = 110

export const OPTIONS_KEY_CONFIGURABLE = 'configurable-options'
export const OPTIONS_KEY_BUNDLE = 'bundle-options'
export const OPTIONS_KEY_GROUPED = 'grouped-options'
export const OPTIONS_KEY_GIFTCARD = 'giftcard-options'
export const OPTIONS_KEY_CUSTOM = 'custom-options'

export const WORK_WITH_US_AREA_TYPE = 'workwithus_area'
export const WORK_WITH_US_POSITION_TYPE = 'workwithus_position'
export const WORK_WITH_US_POSITION_FILTER_KEYS = ['area']
export const WORK_WITH_US_POSITION_DEFAULT_SORT = { code: 'order', direction: 'desc' }
export const WORK_WITH_US_POSITION_DEFAULT_ORDER = ['metadata.wwup_order asc']

export const ADDRESS_COUNTRIES_TYPE_ALL = 'all'
export const ADDRESS_COUNTRIES_TYPE_SHIPPING = 'shipping'

export const INVOICE_REQUEST_FIELD_NAME = 'request_invoice'
export const INVOICE_FIELD_NAME_NATIONAL_IDENTIFICATION_NUMBER = 'national_identification_number'
export const INVOICE_FIELD_NAME_VAT_NUMBER = 'vat_number'
export const INVOICE_FIELD_NAME_DESTINATION_CODE = 'destination_code'
export const INVOICE_FIELD_NAME_COMPANY_NAME = 'company_name'
export const INVOICE_FIELD_NAME_PEC_EMAIL = 'pec_email'
export const INVOICE_FIELD_NAME_REGISTERED_OFFICE = 'registered_office'

export const VIDEO_BACKGROUND_COMPONENT = 'video-background'
export const VIDEO_COMPONENT = 'video'
export const IMAGE_BACKGROUND_COMPONENT = 'image-background'
export const IMAGE_COMPONENT = 'image'
// https://nextjs.org/docs/pages/api-reference/components/image#priority
export const IMAGE_LOADING_EAGER = 'eager'
export const IMAGE_LOADING_LAZY = 'lazy'
export const IMAGE_DEFAULT_PRIORITY = false
export const IMAGE_DEFAULT_LOADING = IMAGE_LOADING_LAZY

export const PAYMENT_METHOD_GATEWAY_DEFAULT = 'default'

export const BAIDU_AUTOCOMPLETE_SERVICE = 'autocomplete'
export const BAIDU_LOCAL_SEARCH_SERVICE = 'local-search'

export const EXTERNAL_COUNTRIES_GROUP_ID = 'EXTERNAL COUNTRIES'

export const NOOP = () => {}

export const IN_VIEW_ROOT_MARGIN_DEFAULT = '500px 0px'
